export default "__VITE_ASSET__MbFANGxB__"